// Utils
import http from '../../../../utils/services/http';

// Constants
import { METHODS } from '../../../../../common/utils/http/httpConstants';

export const fetchTrashService = ({ before, beforeId, otherUsers }) =>
    http({
        url: 'users/me/trash',
        timeout: 60000,
        params: {
            before,
            beforeId,
            'other-users': otherUsers,
        },
    }).then((res) => res.data);

export const emptyTrashService = () => http({ url: 'users/me/trash', method: METHODS.DELETE }).then((res) => res.data);
